import React from 'react';
import { get } from 'lodash';

import { ConfirmDrawerDiv, StyledButton } from 'components/Styled';

const ConfirmDrawer = props => {
  const {
    title,
    btnTitle,
    visible,
    onClose,
    btnClick,
    btnLoading,
    children
  } = props;
  const height = get(props, 'height') || '40%';

  return (
    <div>
      <ConfirmDrawerDiv
        placement="bottom"
        onClose={btnLoading ? () => {} : onClose}
        visible={visible}
        height={height}
        title={title}
        closable={!btnLoading}>
        <div className="text-center children">{children}</div>
        <div className="btn-group text-center">
          <StyledButton
            type="primary"
            shadow="true"
            loading={btnLoading}
            onClick={btnClick}>
            {btnTitle}
          </StyledButton>
        </div>
      </ConfirmDrawerDiv>
    </div>
  );
};

export default ConfirmDrawer;
